module.exports = __webpack_public_path__ + "static/logo-fe1340778135fcd52cbed3951a613cf8.png";